import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  OnInit,
  SimpleChanges,
  OnChanges
} from '@angular/core';

@Component({
  selector: 'cpd-flat-button',
  templateUrl: './flat-button.component.html',
  styleUrls: ['./flat-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlatButtonComponent implements OnInit, OnChanges {
  @Input() text: string;

  @Input() fontSet = 'fas';
  @Input() fontIcon: string;
  @Input() iconSide: 'left' | 'right' = 'left';

  @Input() color: 'basic' | 'primary' | 'secondary' | 'transparent' = 'basic';
  @Input() size: 'small' | 'medium' | 'large';
  @Input() fontWeight: 'normal' | 'semibold' = 'normal';
  @Input() fullWidth = false;
  @Input() disabled = false;
  @Input() type = 'button';

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() click = new EventEmitter<Event>();

  ngClass: any;

  ngOnInit() {
    this.calcNgClass();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes.text && !changes.text.isFirstChange()) ||
      (changes.color && !changes.color.isFirstChange()) ||
      (changes.size && !changes.size.isFirstChange()) ||
      (changes.fullWidth && !changes.fullWidth.isFirstChange()) ||
      (changes.disabled && !changes.disabled.isFirstChange())
    ) {
      this.calcNgClass();
    }
  }

  calcNgClass() {
    this.ngClass = {
      disabled: this.disabled,

      'text-black bg-white hover:bg-white-over': this.color === 'basic',
      'bg-green hover:bg-green-hover': this.color === 'primary',
      'bg-blue hover:bg-blue-hover': this.color === 'secondary',
      'text-white': this.color === 'primary' || this.color === 'secondary',
      'bg-transparent': this.color === 'transparent',
      'font-medium': this.fontWeight === 'normal',
      'font-semibold': this.fontWeight === 'semibold',

      responsive: this.size === undefined,
      small: this.size === 'small',
      medium: this.size === 'medium',
      large: this.size === 'large',

      'full-width': this.fullWidth
    };
  }

  onClick(event: Event) {
    event.stopPropagation();
    if (this.click.observers.length > 0 && !this.disabled) {
      this.click.emit(event);
    }
  }
}
